<oqs-top-panel
  oqs-logo-url="broker.data.quoteDefinition.sbuDetails.webLogoUrl"
  oqs-logo-link="broker.getSbuWebsite()"
  oqs-title-message-key="broker.heading.brokerSelectionHeading">
</oqs-top-panel>

<div class="oqs-left-panel-broker-selection">
  <a ui-sref="summary" class="oqs-broker-select btn btn-lg btn-block"
     ng-class="{'disabled btn-default': !broker.data.selectedBroker, 'btn-primary': broker.data.selectedBroker}">
    <div><span class="fa fa-chevron-circle-right fa-2x"></span></div>
    <span ng-show="$parent.broker.data.selectedBroker" oqs-message="broker.button.continueWithBrokerButton"></span>
    <span ng-if="!$parent.broker.data.selectedBroker" oqs-message="broker.button.selectBrokerButton"></span>
  </a>

  <form name="brokerform" novalidate class="oqs-broker-form form-inline" ng-submit="brokerform.$valid && broker.getBrokerList()">
      <div class="form-group">
        <label for="brokerPostalCode">Postal Code</label>

        <div class="input-group">
          <input id="brokerPostalCode" class="form-control" type="text"
                 ng-model="broker.data.brokerPostalCode"
                 ng-pattern="broker.postalCodePattern"
                 ng-change="broker.updatePostalCodeAnswer()"
                 ng-required="true"
            />
          <span class="input-group-btn">
            <button class="btn btn-default" type="submit"><span
              class="fa fa-search"></span></button>
          </span>
        </div>
      </div>
  </form>
</div>
<div class="oqs-left-panel-broker-list">
  <div class="oqs-quote-spinner" ng-if="broker.data.brokerListRequestInProgress">
    <span class="fa fa-spinner fa-pulse"></span>
  </div>
  <div class="oqs-broker-list-group list-group">
    <div class="oqs-broker-list-group-item list-group-item"
         ng-repeat="brokerItem in broker.data.brokerList.brokers track by brokerItem.id"
         ng-click="broker.selectBroker(brokerItem)" ng-class="{'active': brokerItem == broker.data.selectedBroker}"
         ng-attr-id="broker_{{brokerItem.id}}">
      <div class="oqs-broker-map-label">
        <span class="label label-primary">{{brokerItem.pinLabel}}</span>
      </div>
      <div class="oqs-broker-logo hidden-xs">
        <img ng-if="brokerItem.logoUrl" ng-src="{{brokerItem.logoUrl}}"/>
      </div>
      <h5 class="list-group-item-heading">
        {{brokerItem.name}}
      </h5>

      <div class="list-group-item-text hidden-xs">
        <div class="oqs-broker-address">{{brokerItem.address}}</div>
        <div ng-if="brokerItem.phoneNumber" class="oqs-broker-phone" ng-bind="brokerItem.phoneNumber | tel">
        </div>
        <a ng-if="brokerItem.website" ng-href="{{brokerItem.website}}" target="_blank" title="{{brokerItem.website}}">
          <span class="fa fa-globe"></span> Website
        </a>
      </div>
    </div>
  </div>
  <uib-alert class="oqs-animate-fade" type="info" ng-if="!broker.data.brokerListRequestInProgress && broker.data.brokerList.brokers.length < 1" >
    <span oqs-message="broker.html.noBrokersFoundMessage" oqs-message-html></span>
  </uib-alert>
</div>
<div class="oqs-right-panel-broker-map">
  <p class="oqs-quote-spinner" ng-if="!broker.isMapReady"><span class="fa fa-spinner fa-pulse"></span>
  </p>
  <ui-gmap-google-map ng-if="broker.isMapReady"
                      center="broker.data.brokerList.location"
                      zoom="broker.map.zoom"
                      control="broker.map.control"
                      events="broker.map.events">
    <ui-gmap-markers ng-if="broker.data.brokerList"
                     models="broker.data.brokerList.brokers"
                     coords="'self'" icon="'icon'" fit="true"
                     click="broker.markerClick">
      <ui-gmap-windows show="show">
        <div ng-non-bindable>
          <h5>{{name}}</h5>

          <div class="oqs-broker-address">{{address}}</div>
          <div ng-if="phoneNumber" class="oqs-broker-phone" ng-bind="phoneNumber | tel">
          </div>
        </div>
      </ui-gmap-windows>
    </ui-gmap-markers>
  </ui-gmap-google-map>
</div>


